import { isFunction } from '../is-function/is-function';
import type { Constructor } from '@pct-ts/typing';

export function isConstructor<T>(value: unknown): value is Constructor<T> {
  if (!isFunction(value)) {
    return false;
  }

  if (!value.prototype || value.prototype.constructor !== value) {
    return false;
  }

  // Check if it's a class constructor by examining its string representation
  // Class constructors start with "class" when converted to string
  return /^\s*class\s+/.test(Function.prototype.toString.call(value));
}
